var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#285FCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 5.04688L10.8682 11.958H9.22754L8.99512 5.04688H11.0938ZM8.94043 14.0977C8.94043 13.806 9.04069 13.5645 9.24121 13.373C9.44629 13.1771 9.71517 13.0791 10.0479 13.0791C10.3851 13.0791 10.654 13.1771 10.8545 13.373C11.055 13.5645 11.1553 13.806 11.1553 14.0977C11.1553 14.3802 11.055 14.6195 10.8545 14.8154C10.654 15.0114 10.3851 15.1094 10.0479 15.1094C9.71517 15.1094 9.44629 15.0114 9.24121 14.8154C9.04069 14.6195 8.94043 14.3802 8.94043 14.0977Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconBlue);
export default __webpack_public_path__ + "static/media/alert-icon-blue.eb2700f2.svg";
export { ForwardRef as ReactComponent };